module.exports = __webpack_public_path__ + "static/img/15203136511.889ac67.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/15203136511.jpg
// module id = Z+3c
// module chunks = 0